import { render, staticRenderFns } from "./LoginAndSignupForm.vue?vue&type=template&id=95f48c00&scoped=true"
import script from "./LoginAndSignupForm.vue?vue&type=script&lang=ts"
export * from "./LoginAndSignupForm.vue?vue&type=script&lang=ts"
import style0 from "./LoginAndSignupForm.vue?vue&type=style&index=0&id=95f48c00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f48c00",
  null
  
)

export default component.exports